var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgF3(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    "aria-hidden": "true",
    xmlns: "http://www.w3.org/2000/svg",
    width: 200,
    height: 213,
    viewBox: "0 0 200 213",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_29",
    "data-name": "Group 29",
    transform: "translate(-1082.5 -1978)"
  }, /*#__PURE__*/React.createElement("text", {
    id: "their_jobs",
    "data-name": "their jobs",
    transform: "translate(1182.5 2095)",
    fill: "#265c7e",
    fontSize: 77,
    fontFamily: "Oswald-Bold, Oswald",
    fontWeight: 700,
    letterSpacing: "-0.06em"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -83.275,
    y: 0
  }, "THEIR"), /*#__PURE__*/React.createElement("tspan", {
    x: -71.494,
    y: 70
  }, "JOBS")), /*#__PURE__*/React.createElement("text", {
    id: "following_an_assault",
    "data-name": "following an assault",
    transform: "translate(1181.5 2188)",
    fill: "#1d1d1d",
    fontSize: 16,
    fontFamily: "Lato-Regular, Lato"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -68.92,
    y: 0
  }, "following an assault")), /*#__PURE__*/React.createElement("text", {
    id: "Half_of_sexual_assault_survivors_lose_or_leave",
    "data-name": "Half of sexual assault survivors lose or leave",
    transform: "translate(1182.5 2002)",
    fill: "#1d1d1d",
    fontSize: 20,
    fontFamily: "Oswald-Medium, Oswald",
    fontWeight: 500,
    letterSpacing: "-0.03em"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -95.44,
    y: 0
  }, "HALF OF SEXUAL ASSAULT "), /*#__PURE__*/React.createElement("tspan", {
    x: -99.05,
    y: 22
  }, "SURVIVORS LOSE OR LEAVE")))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgF3);
export default __webpack_public_path__ + "static/media/f3.6a7e14cf04138343189815bc459878d7.svg";
export { ForwardRef as ReactComponent };